module.exports = __webpack_public_path__ + "static/media/copy-icon.7c2cd860.svg";